module.exports = __webpack_public_path__ + "img/mode-light.9a9a1864.svg";